// Wholesale Paper Bowl Product - Recyclable
console.log('🥣 Loading Wholesale Paper Bowl (Recyclable) JavaScript...');

// Variant mapping with real Shopify variant IDs - Paper bowl sizes (8oz, 16oz, 20oz, 25oz, 30oz)
const variantMapping = {
  '8oz': {
    '10000': '51406179172634',
    '16000': '51406179205402',
    '32000': '51406179238170',
    '50000': '51406179270938',
    '64000': '51406179303706'
  },
  '16oz': {
    '10000': '51406179336474',
    '16000': '51406179369242',
    '32000': '51406179402010',
    '50000': '51406179434778',
    '64000': '51406179467546'
  },
  '20oz': {
    '10000': '51406179500314',
    '16000': '51406179533082',
    '32000': '51406179565850',
    '50000': '51406179598618',
    '64000': '51406179631386'
  },
  '25oz': {
    '10000': '51406179664154',
    '16000': '51406179696922',
    '32000': '51406179729690',
    '50000': '51406179762458',
    '64000': '51406179795226'
  },
  '30oz': {
    '10000': '51406179827994',
    '16000': '51406179860762',
    '32000': '51406179893530',
    '50000': '51406179926298',
    '64000': '51406179959066'
  }
};

// Lid variant mapping - real Shopify variant IDs
const lidVariantMapping = {
  "Flat White": {
    "10000": "51751813742874",
    "16000": "51751813841178",
    "32000": "51751813939482",
    "50000": "51751814037786",
    "64000": "51751814136090"
  },
  "Flat Black": {
    "10000": "51751813775642",
    "16000": "51751813873946",
    "32000": "51751813972250",
    "50000": "51751814070554",
    "64000": "51751814168858"
  },
  "Flat Clear": {
    "10000": "51751813808410",
    "16000": "51751813906714",
    "32000": "51751814005018",
    "50000": "51751814103322",
    "64000": "51751814201626"
  },
  "Dome Clear (No Hole)": {
    "10000": "51751813447962",
    "16000": "51751813513498",
    "32000": "51751813579034",
    "50000": "51751813644570",
    "64000": "51751813710106"
  },
  "Dome Clear (With Hole)": {
    "10000": "51810695872794",
    "16000": "51810695905562",
    "32000": "51810695938330",
    "50000": "51810695971098",
    "64000": "51810696003866"
  },
  "High Dome Clear": {
    "10000": "51751814299930",
    "16000": "51751814398234",
    "32000": "51751814496538",
    "50000": "51751814594842",
    "64000": "51751814693146"
  }
};

// Plate fee variant IDs (no lids for paper bowl products)
const plateFeeVariantId = '51810726084890'; // Bowl plate fee ID
const urgentPlateFeeVariantId = '50971398045978'; // Urgent plate fee $250

// Colour restrictions by quantity (match cups wholesale)
const colourRules = {
  '10000': 1,   // 1 colour only
  '16000': 2,   // 1-2 colours
  '32000': 3,   // 1-3 colours
  '50000': 4,   // 1-4 colours
  '64000': 5    // 1-5 colours
};

// Rush fee variant ID ($1 product for calculated rush fees)
const rushFeeVariantId = '50675778126106';

class PaperBowlWholesaleProduct {
  constructor() {
    console.log('PaperBowlWholesaleProduct initialized');

    // State
    this.selectedSize = '8oz';
    this.selectedPrintType = 'Flexographic';
    this.selectedQuantity = 10000;
    this.selectedColours = 1;
    this.requireLids = false;
    this.lidType = '';
    this.selectedTurnaround = 'standard';

    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;

    // Constants
    this.UNITS_PER_CARTON = 1000;
    this.LID_PRICE = 0.059; // $0.059 per lid
    this.URGENT_PLATE_FEE = 250; // $250 plate fee (expedited production options)

    // Rush multipliers (same fee % as bowl supplier: Express +10%, Rushed +35%; labels match wholesale cup format)
    this.RUSH_MULTIPLIERS = {
      standard: 1.0,
      '20days': 1.1,
      '10days': 1.35
    };

    // Colour rules based on quantity
    this.colourRules = {
      10000: { min: 1, max: 1 },
      16000: { min: 1, max: 2 },
      32000: { min: 1, max: 3 },
      50000: { min: 1, max: 4 },
      64000: { min: 1, max: 5 }
    };

    // Variant mappings
    this.variantMapping = variantMapping;
    this.lidVariantMapping = lidVariantMapping;

    this.init().catch(error => console.error('Initialization error:', error));
  }

  async init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupColourSelector();
    this.setupLidsSelector();
    this.setupTurnaroundSelector();
    this.setupTooltips();
    this.setupShippingCalculator();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.updateShippingCalculator();
    this.setupDynamicDescription();
    await this.loadProductData();
    await this.loadLidVariantImages(); // Preload lid variant images for thumbnail preview
    this.rebuildVariantMappingFromProductData();
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial size/print combination
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  getRushMultiplier() {
    const m = this.RUSH_MULTIPLIERS?.[this.selectedTurnaround];
    return typeof m === 'number' && !Number.isNaN(m) ? m : 1.0;
  }

  /** Line-item property: matches on-page print label (avoids Flexographic vs “Wholesale Print” mismatch in cart). */
  getCartPrintTypeLabel() {
    return 'Wholesale Print';
  }

  /** Human-readable turnaround for cart properties and emails. */
  getTurnaroundCartLabel() {
    switch (this.selectedTurnaround) {
      case 'standard':
        return 'Standard (30 business days)';
      case '20days':
        return 'Express (20 business days) +10%';
      case '10days':
        return 'Rushed (10 business days) +35%';
      default:
        return String(this.selectedTurnaround);
    }
  }

  // Build mapping from ProductJSON variant titles to ensure IDs match the current product
  rebuildVariantMappingFromProductData() {
    try {
      if (!this.productData || !Array.isArray(this.productData.variants)) return;

      const built = { '8oz': {}, '16oz': {}, '20oz': {}, '25oz': {}, '30oz': {} };
      const quantities = [10000, 16000, 32000, 50000, 64000];

      this.productData.variants.forEach(v => {
        const title = (v.title || '').toLowerCase();
        // Expect titles to contain size like "8oz", "16oz" and quantity like "10000", "16000", etc.
        const sizeMatch = title.match(/(8|16|20|25|30)oz/);
        const qtyMatch = title.match(/(10000|16000|32000|50000|64000)/);
        if (!sizeMatch || !qtyMatch) return;

        const size = `${sizeMatch[1]}oz`;
        const qty = qtyMatch[1];

        if (built[size]) {
          built[size][qty] = String(v.id);
        }
      });

      const foundAny = Object.values(built).some(map => Object.keys(map).length > 0);
      if (foundAny) {
        console.log('[Mapping] Rebuilt variant mapping from product data (paper-bowl recyclable):', built);
        for (const size of Object.keys(built)) {
          this.variantMapping[size] = { ...(this.variantMapping[size] || {}), ...built[size] };
        }
      }
    } catch (e) {
      console.warn('Failed to rebuild variant mapping from product data (paper-bowl recyclable):', e);
    }
  }

  // Auto-select MOQ quantity based on size and print type
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];

    if (!variants) return;

    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ

    console.log(`Auto-selecting MOQ for ${pricingKey}: ${moqQuantity}`);

    // Update the selected quantity
    this.selectedQuantity = moqQuantity;

    // Update available colours based on quantity
    this.updateColourAvailability();
  }

  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);

    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);

        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);

        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when size changes
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);

    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedPrintType = btn.dataset.printType;
        console.log('[PrintType Debug] Print type selected:', this.selectedPrintType);

        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when print type changes
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupColourSelector() {
    const colourButtons = document.querySelectorAll('.color-btn');
    colourButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Only allow selection if not disabled
        if (btn.classList.contains('disabled')) return;

        // Update selection
        colourButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedColours = parseInt(btn.dataset.colors);
        console.log('Colours selected:', this.selectedColours);

        this.updatePricingTable();
      });
    });
  }

  setupLidsSelector() {
    const lidTypeSelect = document.getElementById('lid-type-select');
    const trigger = document.getElementById('custom-lid-dropdown-trigger');
    const list = document.getElementById('custom-lid-dropdown-list');
    const label = document.getElementById('custom-lid-dropdown-label');

    const openDropdown = () => {
      list.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const closeDropdown = () => {
      list.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    const selectOption = (value, text) => {
      // Update hidden native select (for form submission)
      if (lidTypeSelect) {
        lidTypeSelect.value = value;
        lidTypeSelect.dispatchEvent(new Event('change'));
      }
      // Update label text
      if (label) label.textContent = text;
      // Update selected class on options
      if (list) {
        list.querySelectorAll('.custom-lid-dropdown__option').forEach(opt => {
          const isSelected = opt.dataset.value === value;
          opt.classList.toggle('selected', isSelected);
          opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
      }
      closeDropdown();
    };

    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        list.classList.contains('open') ? closeDropdown() : openDropdown();
      });
    }

    if (list) {
      list.querySelectorAll('.custom-lid-dropdown__option').forEach(opt => {
        opt.addEventListener('click', (e) => {
          e.stopPropagation();
          selectOption(opt.dataset.value, opt.textContent.trim());
        });
        // Touch-friendly: respond to touchend to avoid 300ms delay
        opt.addEventListener('touchend', (e) => {
          e.preventDefault();
          selectOption(opt.dataset.value, opt.textContent.trim());
        });
      });
    }

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('#custom-lid-dropdown')) closeDropdown();
    });

    if (lidTypeSelect) {
      lidTypeSelect.addEventListener('change', (e) => {
        const value = e.target.value;
        if (value === 'no') {
          this.requireLids = false;
          this.lidType = '';
        } else {
          this.requireLids = true;
          this.lidType = value;
        }
        console.log('Lid selection updated:', { requireLids: this.requireLids, lidType: this.lidType });
        this.updatePricingTable();
        this.updateLidPreview();
      });

      // Initial call
      this.updateLidPreview();
    }
  }

  async loadLidVariantImages() {
    if (this.lidVariantIdToImage) return this.lidVariantIdToImage;
    // Use the section that contains our lid product handle (not the first [data-section] on the page)
    const productInfo = document.querySelector('[data-lid-product-handle]');
    const sectionId = productInfo?.getAttribute('data-section');
    const handle = productInfo?.dataset?.lidProductHandle?.trim();
    const scriptEl = sectionId ? document.getElementById(`LidVariantImages-${sectionId}`) : null;
    const mappingEl = sectionId ? document.getElementById(`LidVariantMapping-${sectionId}`) : null;
    if (scriptEl && scriptEl.textContent) {
      try {
        this.lidVariantIdToImage = JSON.parse(scriptEl.textContent);
        const imageCount = Object.keys(this.lidVariantIdToImage || {}).length;
        if (mappingEl && mappingEl.textContent) {
          try {
            this.lidVariantMappingFromProduct = JSON.parse(mappingEl.textContent);
          } catch (_) {}
        }
        console.log('[Lid Preview] Loaded from Liquid: images=', imageCount, 'handle=', handle);
        if (imageCount === 0 && handle) {
          console.warn('[Lid Preview] Lid product has no variant images. Ensure each lid variant has a featured image in Shopify Admin.');
        }
        return this.lidVariantIdToImage;
      } catch (e) {
        console.warn('[Lid Preview] Failed to parse LidVariantImages:', e);
      }
    } else if (productInfo?.dataset?.lidProductHandle && !sectionId) {
      console.warn('[Lid Preview] Could not find section ID. Lid preview may not work.');
    }
    if (!scriptEl && handle) {
      console.log('[Lid Preview] Scripts not found, fetching from /products/' + handle + '.js');
    }
    if (handle) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (res.ok) {
          const product = await res.json();
          this.lidVariantIdToImage = {};
          this.lidVariantMappingFromProduct = {};
          (product.variants || []).forEach(v => {
            const img = v?.featured_image || v?.featured_media?.preview_image;
            if (img) {
              const src = typeof img === 'string' ? img : (img.src || img.url);
              if (src) this.lidVariantIdToImage[String(v.id)] = src;
            }
            // Build dynamic mapping: match variant by lid type + quantity in title/options
            const title = (v.title || '').toLowerCase();
            const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(o => (o || '').toLowerCase());
            const quantities = ['10000', '16000', '32000', '50000', '64000'];
            const lidTypes = Object.keys(this.lidVariantMapping);
            for (const lt of lidTypes) {
              const ltNorm = lt.toLowerCase().replace(/\s*\([^)]*\)/g, '').trim();
              const ltMatch = title.includes(ltNorm) || opts.some(o => o.includes(ltNorm));
              if (!ltMatch) continue;
              for (const q of quantities) {
                const qMatch = title.includes(q) || opts.some(o => o.includes(q));
                if (qMatch) {
                  if (!this.lidVariantMappingFromProduct[lt]) this.lidVariantMappingFromProduct[lt] = {};
                  this.lidVariantMappingFromProduct[lt][q] = String(v.id);
                  break;
                }
              }
            }
          });
          const imgCnt = Object.keys(this.lidVariantIdToImage || {}).length;
          const mapCnt = Object.keys(this.lidVariantMappingFromProduct || {}).length;
          console.log('[Lid Preview] Loaded from fetch: images=', imgCnt, 'lidTypes=', mapCnt);
          return this.lidVariantIdToImage;
        }
      } catch (e) {
        console.warn('[Lid Preview] Fetch failed:', e);
      }
    }
    this.lidVariantIdToImage = {};
    return this.lidVariantIdToImage;
  }

  getLidVariantIdForPreview() {
    const qty = String(this.selectedQuantity);
    // Prefer dynamic mapping from Liquid or fetch (uses actual store variant IDs)
    const dynamicId = this.lidVariantMappingFromProduct?.[this.lidType]?.[qty];
    if (dynamicId) return dynamicId;

    // Use hardcoded if dynamic mapping is empty/null
    return this.lidVariantMapping[this.lidType]?.[qty] || null;
  }

  updateLidPreview() {
    const desktopOverlay = document.getElementById('lid-preview-overlay-desktop');
    const mobilePreview = document.getElementById('lid-preview-mobile');
    const desktopImg = document.getElementById('lid-preview-img-desktop');
    const mobileImg = document.getElementById('lid-preview-img-mobile');

    if (!this.requireLids || !this.lidType) {
      if (desktopOverlay) desktopOverlay.style.setProperty('display', 'none', 'important');
      if (mobilePreview) mobilePreview.style.setProperty('display', 'none', 'important');
      return;
    }

    const fallbackFromSetting = document.querySelector('[data-lid-fallback-image]')?.dataset?.lidFallbackImage?.trim();
    const fallbackChain = [this.lidImageMapping[this.lidType], fallbackFromSetting].filter(Boolean);

    const setImage = (imageUrl, fallbackIndex = 0) => {
      if (imageUrl) {
        if (desktopImg) {
          desktopImg.onerror = () => {
            const next = fallbackChain[fallbackIndex + 1];
            if (next && next !== imageUrl) setImage(next, fallbackIndex + 1);
            else if (desktopOverlay) desktopOverlay.style.setProperty('display', 'none', 'important');
          };
          desktopImg.src = imageUrl;
          if (desktopOverlay) desktopOverlay.style.setProperty('display', 'flex', 'important');
        }
        if (mobileImg) {
          mobileImg.onerror = () => {
            const next = fallbackChain[fallbackIndex + 1];
            if (next && next !== imageUrl) setImage(next, fallbackIndex + 1);
            else if (mobilePreview) mobilePreview.style.setProperty('display', 'none', 'important');
          };
          mobileImg.src = imageUrl;
          if (mobilePreview) mobilePreview.style.setProperty('display', 'flex', 'important');
        }
      } else {
        if (desktopOverlay) desktopOverlay.style.setProperty('display', 'none', 'important');
        if (mobilePreview) mobilePreview.style.setProperty('display', 'none', 'important');
      }
    };
    const trySetImage = (vid) => {
      if (!vid) return null;
      return this.lidVariantIdToImage?.[String(vid)] || null;
    };
    let lidVariantId = this.getLidVariantIdForPreview();
    let imageUrl = lidVariantId ? trySetImage(lidVariantId) : null;
    if (imageUrl) {
      console.log('[Lid Preview] Using variant image:', lidVariantId, imageUrl?.slice(0, 60) + '...');
      setImage(imageUrl);
      return;
    }
    this.loadLidVariantImages().then(() => {
      lidVariantId = this.getLidVariantIdForPreview();
      imageUrl = lidVariantId ? trySetImage(lidVariantId) : null;
      const fallbackUrl = imageUrl || this.lidImageMapping[this.lidType] || fallbackFromSetting;
      console.log('[Lid Preview] lidType:', this.lidType, 'qty:', this.selectedQuantity, 'variantId:', lidVariantId, 'imageFound:', !!imageUrl, 'usingFallback:', !imageUrl);
      if (lidVariantId && !imageUrl) {
        console.warn('[Lid Preview] Variant', lidVariantId, 'not found in images. Check: 1) Lid product handle is set, 2) Each lid variant has a featured image.');
      }
      setImage(fallbackUrl);
    });
  }

  setupTurnaroundSelector() {
    const turnaroundButtons = document.querySelectorAll('.turnaround-pill');
    if (turnaroundButtons.length === 0) {
      console.warn('No turnaround pills found');
      return;
    }

    turnaroundButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        turnaroundButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedTurnaround = btn.dataset.turnaround || 'standard';
        console.log('Turnaround selected:', this.selectedTurnaround);

        this.updatePricingTable();
        this.updateShippingCalculator();
        this.updateOrderSummary();
      });
    });
  }

  // Get pricing key for variant lookup
  getPricingKey() {
    return this.selectedSize;
  }

  // Map bowl quantity to lid variant quantity tier (same pattern as cup wholesale)
  getLidQuantityTier(qty) {
    if (qty >= 64000) return '64000';
    if (qty >= 50000) return '50000';
    if (qty >= 32000) return '32000';
    if (qty >= 16000) return '16000';
    return '10000';
  }

  // Update colour availability based on selected quantity
  updateColourAvailability() {
    const rule = this.colourRules[this.selectedQuantity];
    if (!rule) return;

    const colourButtons = document.querySelectorAll('.color-btn');
    const availabilityText = document.querySelector('#color-availability-note');

    colourButtons.forEach(btn => {
      const colourCount = parseInt(btn.dataset.colors);

      if (colourCount >= rule.min && colourCount <= rule.max) {
        btn.classList.remove('disabled');
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      } else {
        btn.classList.add('disabled');
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';

        // Deselect if currently selected
        if (btn.classList.contains('selected')) {
          btn.classList.remove('selected');
          // Auto-select the maximum allowed
          const maxAllowedBtn = document.querySelector(`.color-btn[data-colors="${rule.max}"]`);
          if (maxAllowedBtn && !maxAllowedBtn.classList.contains('disabled')) {
            maxAllowedBtn.classList.add('selected');
            this.selectedColours = rule.max;
          }
        }
      }
    });

    if (availabilityText) {
      availabilityText.textContent = rule.min === rule.max
        ? `Available colours: ${rule.min} for selected quantity`
        : `Available colours: ${rule.min}-${rule.max} for selected quantity`;
    }
  }

  // Load product data for pricing
  async loadProductData() {
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('[Product Data] Loaded from existing script:', this.productData?.title);
        return;
      }

      // Fallback: get from window.meta or handle
      const productHandle = window.meta?.product?.handle || this.extractProductHandle();
      if (!productHandle) {
        console.warn('[Product Data] Could not determine product handle');
        return null;
      }

      console.log('[Product Data] Loading for handle:', productHandle);

      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      this.productData = await response.json();
      console.log('[Product Data] Loaded via API:', this.productData?.title);

    } catch (error) {
      console.warn('[Product Data] Failed to load:', error);
      this.productData = null;
    }
  }

  extractProductHandle() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  async updatePricingTable() {
    const tbody = document.getElementById('quantity-grid-body');
    if (!tbody) { console.log('No pricing table found'); return; }

    // Get the current pricing key (just size for this product)
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];

    if (!variants) {
      console.log('No variants found for pricing key:', pricingKey);
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }

    await this.loadProductData();
    tbody.innerHTML = '';

    // Get available quantities for this configuration (wholesale quantities)
    const quantities = [10000, 16000, 32000, 50000, 64000];

    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];

      // Try to find variant in product data
      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;

      if (this.productData && variantId) {
        // Prefer exact id match, else try to resolve by title text (size + qty) as fallback
        variant = this.productData.variants.find(v => v.id == variantId);
        if (!variant) {
          const qtyDigits = String(qty);
          const sizeNorm = this.selectedSize.toLowerCase();
          variant = this.productData.variants.find(v => {
            const title = (v.title || '').toLowerCase();
            const titleDigits = (v.title || '').replace(/[^0-9]/g, '');
            const opts = [v.option1, v.option2, v.option3].map(o => (o || '').toLowerCase());
            const sizeMatch = opts.includes(sizeNorm) || title.includes(`${sizeNorm} `) || title.startsWith(`${sizeNorm} /`) || title.includes(`${sizeNorm}/`);
            const qtyMatch = titleDigits.includes(qtyDigits);
            return sizeMatch && qtyMatch;
          }) || null;
        }
      }

      console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);

      if (variant) {
        // Use live Shopify pricing; handle cents or string formats
        const raw = typeof variant.price === 'string' ? parseFloat(variant.price) : Number(variant.price);
        const dollars = isNaN(raw) ? 0 : (raw >= 1000 ? Math.round(raw) / 100 : raw);
        variantPrice = dollars;
        unitPrice = variantPrice / qty;
      } else {
        // Fallback: calculate estimated pricing based on wholesale quantity tiers
        console.warn(`Using fallback pricing for ${pricingKey} ${qty} units (variant ${variantId} not found or empty)`);

        // Wholesale tiered pricing fallback for paper bowls
        if (qty >= 64000) unitPrice = 0.16;
        else if (qty >= 50000) unitPrice = 0.18;
        else if (qty >= 32000) unitPrice = 0.20;
        else if (qty >= 16000) unitPrice = 0.23;
        else unitPrice = 0.26; // 10,000

        // Adjust for paper bowl size
        if (pricingKey.includes('11oz')) {
          unitPrice *= 2.0; // Large paper bowls cost more
        } else if (pricingKey.includes('8oz')) {
          unitPrice *= 1.4;
        } else if (pricingKey.includes('3oz')) {
          unitPrice *= 1.1;
        }

        variantPrice = unitPrice * qty;
      }

      // Calculate costs with plates and rush
      const plateCost = (Number(this.selectedColours) || 0) * 175; // $175 per colour
      const rushMultiplier = this.getRushMultiplier();
      const totalCost = (variantPrice + plateCost) * rushMultiplier;
      const totalUnitPrice = totalCost / qty;

      // Store unit price for the selected quantity
      if (qty === this.selectedQuantity) {
        this.currentUnitPrice = totalUnitPrice;
      }

      // Calculate cartons
      const cartons = qty / this.UNITS_PER_CARTON;

      // Create row like cup-wholesale (radio + membership columns)
      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateColourAvailability();
          this.updateOrderSummary();
          this.updateMediaGalleryForSelectedVariant();
          this.updateLidPreview();
        }
      });

      // Check for membership pricing
      let memberTier = null;
      let discountPercent = 0;

      // Get customer tags from data attribute
      const customerTags = document.querySelector('[data-customer-tags]')?.dataset.customerTags || '';
      if (customerTags) {
        const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());

        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }

      // Build cells
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio'; radio.name = 'quantity_selection'; radio.value = qty;
      radio.addEventListener('change', () => { if (radio.checked) { this.selectedQuantity = qty; this.currentUnitPrice = unitPrice; this.updateRowSelection(); this.updateSelectedQuantityDisplay(); this.updateColourAvailability(); this.updateOrderSummary(); this.updateMediaGalleryForSelectedVariant(); this.updateLidPreview(); } });
      if ((i === 0 && this.selectedQuantity == null) || qty === this.selectedQuantity) { radio.checked = true; this.selectedQuantity = qty; this.currentUnitPrice = unitPrice; row.classList.add('selected'); }
      radioCell.appendChild(radio); row.appendChild(radioCell);

      const qtyCell = document.createElement('td'); qtyCell.textContent = qty.toLocaleString(); row.appendChild(qtyCell);
      const cartonsCell = document.createElement('td'); const qtyCartons = qty / this.UNITS_PER_CARTON; cartonsCell.textContent = this.decimalToFraction(qtyCartons); row.appendChild(cartonsCell);

      const unitPriceCell = document.createElement('td');
      if (memberTier && discountPercent > 0) {
        const discountedUnit = unitPrice * (1 - discountPercent / 100);
        unitPriceCell.innerHTML = `<span class=\"original-price\">$${unitPrice.toFixed(3)}</span><span class=\"member-price member-${memberTier}\">$${discountedUnit.toFixed(3)}</span>`;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(3)}`;
      }
      row.appendChild(unitPriceCell);

      const totalCell = document.createElement('td');
      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        totalCell.innerHTML = `<span class=\"original-price\">$${variantPrice.toFixed(2)}</span><span class=\"member-price member-${memberTier}\">$${discountedTotal.toFixed(2)}</span>`;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

      tbody.appendChild(row);
    }

    this.updateRowSelection(); this.updateSelectedQuantityDisplay(); this.updateOrderSummary(); this.updateMediaGalleryForSelectedVariant();
  }

  // Placeholder mapping for lid images - User to provide actual URLs
  lidImageMapping = {
    "Flat White": "https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Flat_White_Lid.png?v=123",
    "Flat Black": "https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Flat_Black_Lid.png?v=123",
    "Flat Clear": "https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Flat_Clear_Lid.png?v=123",
    "Dome Clear (No Hole)": "https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Dome_No_Hole_Lid.png?v=123",
    "Dome Clear (With Hole)": "https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Dome_With_Hole_Lid.png?v=123",
    "High Dome Clear": "https://cdn.shopify.com/s/files/1/0907/2433/5898/files/High_Dome_Lid.png?v=123"
  };

  updateRowSelection() { document.querySelectorAll('.quantity-row').forEach(row => row.classList.remove('selected')); if (this.selectedQuantity) { const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`); if (selectedRow) selectedRow.classList.add('selected'); } }
  updateSelectedQuantityDisplay() { const els = document.querySelectorAll('.selected-quantity-display'); els.forEach(el => { el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : ''; }); this.updateOrderSummary(); }
  calculateUnitPrice() { return this.currentUnitPrice || 0; }
  calculatePlateFees() {
    const colours = Number(this.selectedColours) || 0;
    // Both production options are expedited; use urgent plate fee tier
    return colours * this.URGENT_PLATE_FEE;
  }
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];
    if (!variant && !this.currentUnitPrice) return;

    let unitPrice = this.calculateUnitPrice();
    let plateFee = this.calculatePlateFees();
    let lidPrice = 0;
    let rushFee = 0;

    // Add lid price if required
    if (this.requireLids && this.lidType) {
      let lidUnitPrice = 0.059; // Base cost 
      if (this.lidType.includes('Dome')) {
         lidUnitPrice = 0.065; // Dome cost slightly more, adjust as desired or link to real variant price later
      }
      lidPrice = this.selectedQuantity * lidUnitPrice;
      const lidRow = document.getElementById('summary-lid-row');
      const lidPriceEl = document.getElementById('summary-lid-price');
      if (lidRow) lidRow.style.display = '';
      if (lidPriceEl) lidPriceEl.textContent = `$${lidPrice.toFixed(2)}`;
    } else {
      const lidRow = document.getElementById('summary-lid-row');
      if (lidRow) lidRow.style.display = 'none';
    }

    let totalPrice = this.selectedQuantity * unitPrice + plateFee + lidPrice;

    const plateFeeEl = document.getElementById('summary-plate-fee');
    if (plateFeeEl) plateFeeEl.textContent = `$${plateFee.toFixed(2)}`;

    const rushMultiplier = this.getRushMultiplier();
    if (rushMultiplier > 1.0) {
      const baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
      rushFee = Math.round(baseCupTotal * (rushMultiplier - 1));
      totalPrice += rushFee;
      const rrow = document.getElementById('summary-rush-row');
      if (rrow) rrow.style.display = '';
      const rfee = document.getElementById('summary-rush-fee');
      if (rfee) rfee.textContent = `$${rushFee.toFixed(2)}`;
    } else {
      const rrow = document.getElementById('summary-rush-row');
      if (rrow) rrow.style.display = 'none';
      const rfee = document.getElementById('summary-rush-fee');
      if (rfee) rfee.textContent = '$0.00';
    }

    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();

    let memberTier = null, discountPercent = 0;
    const customerTags = document.querySelector('[data-customer-tags]')?.dataset.customerTags || '';
    if (customerTags) {
      const tags = customerTags.toLowerCase().split(',').map(t => t.trim());
      if (tags.includes('trade')) { memberTier = 'trade'; discountPercent = 20; }
      else if (tags.includes('gold')) { memberTier = 'gold'; discountPercent = 15; }
      else if (tags.includes('silver')) { memberTier = 'silver'; discountPercent = 10; }
      else if (tags.includes('bronze')) { memberTier = 'bronze'; discountPercent = 5; }
    }

    if (summaryUnitPrice) {
      if (memberTier && discountPercent > 0) {
        const discountedUnit = unitPrice * (1 - discountPercent / 100);
        summaryUnitPrice.innerHTML = `<span class="original-price">$${unitPrice.toFixed(3)}</span><span class="member-price member-${memberTier}">$${discountedUnit.toFixed(3)}</span><span class="membership-badge membership-${memberTier}">${memberTier === 'trade' ? '💎' : memberTier === 'gold' ? '🥇' : memberTier === 'silver' ? '🥈' : '🥉'}</span>`;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(3)}`;
      }
    }

    if (summaryTotal) {
      if (memberTier && discountPercent > 0) {
        const discountedTotal = totalPrice * (1 - discountPercent / 100);
        summaryTotal.innerHTML = `<span class="original-price">$${totalPrice.toFixed(2)}</span><span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>`;
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
      }
    }
  }

  // Utility functions
  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  formatNumber(number) {
    return new Intl.NumberFormat('en-US').format(number);
  }

  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return this.formatNumber(decimal);
    }

    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };

    return fractions[decimal] || this.formatNumber(decimal);
  }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const variantId = this.variantMapping[pricingKey]?.[quantityKey];

    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);

    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);

    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);

    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }

      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);

      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }

      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);

      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }

      // Find the target thumbnail for this media ID
      // Liquid uses: id="Slide-Thumbnails-{{ section.id }}-{{ forloop.index }}"
      // and: data-target="{{ section.id }}-{{ media.id }}"
      const targetThumbnail = document.querySelector(`.thumbnail-list__item[data-target$="-${variant.featured_media.id}"] button`);
      
      if (targetThumbnail) {
        console.log('Clicking thumbnail for media:', variant.featured_media.id);
        targetThumbnail.click();
      } else {
        console.warn('Could not find thumbnail for media:', variant.featured_media.id);
        
        // Fallback: search for any element with the media ID if the thumbnail structure changed
        const sectionId = mediaGallery.dataset.sectionId;
        const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
        const targetMedia = document.querySelector(`[data-media-id="${targetMediaId}"]`);
        if (targetMedia) {
          targetMedia.click();
        }
      }

    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }

  setupTooltips() {
    let activeTooltip = null;
    let activeIcon = null;
    let lastShowTime = 0;
    const TOUCH_HIDE_DELAY = 200;

    const hideAllTooltips = () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => { if (t.parentNode) t.parentNode.removeChild(t); });
      activeTooltip = null;
      activeIcon = null;
    };

    const showTooltip = (icon) => {
      hideAllTooltips();
      const tooltipText = icon.getAttribute('data-tooltip');
      if (!tooltipText) return;
      const tooltip = document.createElement('div');
      tooltip.className = 'tooltip-popup';
      tooltip.innerHTML = tooltipText;
      tooltip.setAttribute('role', 'tooltip');
      Object.assign(tooltip.style, {
        position: 'fixed', background: '#000000', color: '#ffffff', padding: '12px 16px',
        borderRadius: '6px', fontSize: '14px', fontWeight: '400', lineHeight: '1.4',
        maxWidth: '300px', width: 'max-content', whiteSpace: 'normal', wordBreak: 'break-word',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)', zIndex: '99999', opacity: '0',
        visibility: 'hidden', transition: 'opacity 0.2s ease, visibility 0.2s ease',
        pointerEvents: 'none', left: '0', top: '0'
      });
      document.body.appendChild(tooltip);
      activeTooltip = tooltip;
      activeIcon = icon;
      lastShowTime = Date.now();

      const iconRect = icon.getBoundingClientRect();
      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '0';
      const tooltipRect = tooltip.getBoundingClientRect();
      tooltip.style.visibility = 'hidden';
      let left = iconRect.left + (iconRect.width / 2) - (tooltipRect.width / 2);
      let top = iconRect.top - tooltipRect.height - 8;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      if (left < 10) left = 10;
      else if (left + tooltipRect.width > viewportWidth - 10) left = viewportWidth - tooltipRect.width - 10;
      if (top < 10) top = iconRect.bottom + 8;
      else if (top + tooltipRect.height > viewportHeight - 10) top = viewportHeight - tooltipRect.height - 10;
        tooltip.style.setProperty('--tooltip-left', left + 'px');
        tooltip.style.setProperty('--tooltip-top', top + 'px');
        requestAnimationFrame(() => {
        if (activeTooltip === tooltip && tooltip.parentNode) {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        }
      });
    };

    const hideTooltip = () => {
      if (activeTooltip) {
        activeTooltip.style.opacity = '0';
        activeTooltip.style.visibility = 'hidden';
        setTimeout(() => {
          if (activeTooltip && activeTooltip.parentNode) activeTooltip.parentNode.removeChild(activeTooltip);
          activeTooltip = null;
          activeIcon = null;
        }, 200);
      }
    };

    // Use event delegation for robustness (works with dynamically added content)
    document.addEventListener('mouseover', (e) => {
      const icon = e.target.closest('.tooltip-icon[data-tooltip]');
      if (icon && (!e.relatedTarget || !icon.contains(e.relatedTarget))) showTooltip(icon);
    });
    document.addEventListener('mouseout', (e) => {
      const icon = e.target.closest('.tooltip-icon[data-tooltip]');
      if (icon && (!e.relatedTarget || !icon.contains(e.relatedTarget))) hideTooltip();
    });
    document.addEventListener('focusin', (e) => {
      const icon = e.target.closest('.tooltip-icon[data-tooltip]');
      if (icon) showTooltip(icon);
    });
    document.addEventListener('focusout', (e) => {
      const icon = e.target.closest('.tooltip-icon[data-tooltip]');
      if (icon && !e.relatedTarget?.closest?.('.tooltip-icon[data-tooltip]')) hideTooltip();
    });
    document.addEventListener('click', (e) => {
      const icon = e.target.closest('.tooltip-icon[data-tooltip]');
      if (icon) {
        e.preventDefault();
        e.stopPropagation();
        // On touch: tap can fire mouseover (show) then click (hide) - avoid hide if just shown
        const isTouchDevice = 'ontouchstart' in window || window.matchMedia('(pointer: coarse)').matches;
        const justShown = Date.now() - lastShowTime < TOUCH_HIDE_DELAY;
        if (activeTooltip && activeIcon === icon && !(isTouchDevice && justShown)) {
          hideTooltip();
        } else {
          showTooltip(icon);
        }
      } else {
        hideAllTooltips();
      }
    });

    document.addEventListener('scroll', hideAllTooltips, true);
  }

  setupFormSubmission() {
    const form = document.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.addToCartAjax().catch(err => {
        console.error('Add to cart failed:', err);
        this.showMessage(`Error adding to cart: ${err.message}`, 'error');
      });
    });
  }

  setupShippingCalculator() {
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      return;
    }

    let productionDays; let minDeliveryDays; let maxDeliveryDays;
    switch (this.selectedTurnaround) {
      case '10days':
        productionDays = 10; minDeliveryDays = 11; maxDeliveryDays = 13; break;
      case '20days':
        productionDays = 20; minDeliveryDays = 21; maxDeliveryDays = 23; break;
      case 'standard':
      default:
        productionDays = 30; minDeliveryDays = 31; maxDeliveryDays = 33; break;
    }

    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Delivery headline: date range only (rush % belongs on pills / order summary, not here).
    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = formatDate(doorstepDate);
    } else {
      deliveryRangeEl.textContent = `${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }
    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  async addPlateFeeToCart() {
    try {
      const plateVariant = urgentPlateFeeVariantId;

      const plateFeeData = {
        items: [{
          id: plateVariant,
          quantity: this.selectedColours,
          properties: {
            '_plate_fee': 'true',
            '_colors': this.selectedColours,
            '_for_product': this.selectedSize
          }
        }]
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(plateFeeData)
      });

      if (response.ok) {
        console.log('Plate fee added to cart:', this.selectedColours, 'colours');
      } else {
        console.warn('Failed to add plate fee to cart');
      }
    } catch (error) {
      console.error('Error adding plate fee to cart:', error);
    }
  }

  async addToCartAjax() {
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const bowlVariantId = this.variantMapping[pricingKey]?.[quantityKey];
    if (!bowlVariantId) throw new Error('Please select a valid configuration');

    const formData = new FormData();
    const epkCartGroupId = `epkorder-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

    // Bowl variant
    formData.append('items[0][id]', bowlVariantId);
    formData.append('items[0][quantity]', '1');
    formData.append('items[0][properties][_epk_group]', epkCartGroupId);
    formData.append('items[0][properties][Size]', this.selectedSize);
    formData.append('items[0][properties][Print Type]', this.getCartPrintTypeLabel());
    formData.append('items[0][properties][Wholesale Quantity]', this.selectedQuantity);
    formData.append('items[0][properties][Colours]', String(this.selectedColours));
    formData.append('items[0][properties][Turnaround]', this.getTurnaroundCartLabel());
    if (this.requireLids && this.lidType) {
      formData.append('items[0][properties][Lids]', this.lidType);
    }

    let itemIndex = 1;

    // Lids secondary item - direct lookup from lidVariantMapping (same pattern as cup wholesale)
    if (this.requireLids && this.lidType) {
      const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
      const lidVariantId = this.lidVariantMapping[this.lidType]?.[lidQuantityTier];
      if (lidVariantId) {
        formData.append(`items[${itemIndex}][id]`, lidVariantId);
        formData.append(`items[${itemIndex}][quantity]`, '1');
        formData.append(`items[${itemIndex}][properties][Type]`, 'Lids');
        formData.append(`items[${itemIndex}][properties][Style]`, this.lidType);
        formData.append(`items[${itemIndex}][properties][For Product]`, `${this.selectedSize} Bowl`);
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
        itemIndex++;
      }
    }

    // Plate fees per colour
    const plateVariant = urgentPlateFeeVariantId;
    if (this.selectedColours > 0) {
      formData.append(`items[${itemIndex}][id]`, plateVariant);
      formData.append(`items[${itemIndex}][quantity]`, String(this.selectedColours));
      formData.append(`items[${itemIndex}][properties][Type]`, 'Printing Plates');
      formData.append(`items[${itemIndex}][properties][Colours]`, String(this.selectedColours));
      formData.append(`items[${itemIndex}][properties][For Order]`, `${this.selectedSize} ${this.selectedQuantity} bowls`);
      formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
      itemIndex++;
    }

    // Rush fee line for non-members
    const rushMultiplier = this.getRushMultiplier();
    if (rushMultiplier > 1.0) {
      const tags = (window.customer?.tags || []).map(t => String(t).toLowerCase());
      const isMember = tags.some(t => t.includes('bronze') || t.includes('silver') || t.includes('gold') || t.includes('trade'));
      {
        // Rush charged for everyone (members included); Shopify discount applies it once.
        const baseBowlTotal = this.selectedQuantity * this.calculateUnitPrice();
        const rushFeeAmount = baseBowlTotal * (rushMultiplier - 1);
        const rushFeeQuantity = Math.max(0, Math.round(rushFeeAmount));
        if (rushFeeQuantity > 0) {
          formData.append(`items[${itemIndex}][id]`, rushFeeVariantId);
          formData.append(`items[${itemIndex}][quantity]`, String(rushFeeQuantity));
          formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${baseBowlTotal.toFixed(2)}`);
          formData.append(`items[${itemIndex}][properties][Rush Fee (${this.selectedTurnaround})]`, `$${rushFeeAmount.toFixed(2)}`);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
          itemIndex++;
        }
      }
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sections = cartDrawer.getSectionsToRender().map(s => s.id);
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    if (!response.ok) {
      let message = `Failed to add to cart: ${response.status}`;
      try { const j = await response.json(); if (j?.description) message += ` - ${j.description}`; } catch (_) { }
      throw new Error(message);
    }

    const json = await response.json();
    // Do not open cart drawer prior to refresh
    // (Intentionally skipping cartDrawer.renderContents and section refresh here)

    document.dispatchEvent(new CustomEvent('cart:updated'));
    this.showMessage('Added to cart!', 'success');

    // Refresh page shortly after to fully sync UI/state; preserve drawer open state
    try { if (typeof preserveCartDrawerState === 'function') preserveCartDrawerState(); } catch (_) { }
    setTimeout(() => { window.location.reload(); }, 700);
  }

  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';

        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }

  setupShippingCalculator() {
    // Shipping calculation functionality
    const calculateBtn = document.querySelector('.calculate-shipping-btn');
    if (!calculateBtn) return;

    calculateBtn.addEventListener('click', () => {
      const zipCode = document.querySelector('.shipping-zip-input')?.value;
      if (!zipCode) {
        this.showMessage('Please enter a zip code', 'error');
        return;
      }

      // Here you would integrate with shipping API
      console.log('Calculate shipping for:', zipCode, 'quantity:', this.selectedQuantity);
      this.showMessage('Shipping calculated!', 'success');
    });
  }

  setupDynamicDescription() {
    // Initialize description content and accordion behavior
    this.updateDynamicDescription();
    this.setupAccordionBehavior('.dynamic-description');
    this.setupAccordionBehavior('.dynamic-description-mobile');
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopContent = document.getElementById('description-content');
    if (desktopTitle && desktopContent) {
      desktopTitle.classList.add('active');
      desktopContent.classList.add('active');
    }

    // Open description tab on mobile
    const mobileTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileContent = document.getElementById('description-content-mobile');
    if (mobileTitle && mobileContent) {
      mobileTitle.classList.add('active');
      mobileContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const titles = container.querySelectorAll('.dropdown-title');
    titles.forEach((title) => {
      // Ensure bold styling
      title.style.setProperty('font-weight', '700', 'important');

      title.addEventListener('click', () => {
        const targetId = title.getAttribute('data-target');
        const targetEl = document.getElementById(targetId);
        if (!targetEl) return;

        const isActive = title.classList.contains('active');
        // Close all
        titles.forEach((other) => {
          const otherId = other.getAttribute('data-target');
          const otherEl = document.getElementById(otherId);
          other.classList.remove('active');
          if (otherEl) otherEl.classList.remove('active');
        });
        // Toggle current
        if (!isActive) {
          title.classList.add('active');
          targetEl.classList.add('active');
        }
      });
    });
  }

  getDescriptionData() {
    const sizeDescriptions = {
      "8oz": {
        description: `
          <p>Our 8oz Wholesale Custom Paper Bowls offer the perfect balance for single-scoop servings and controlled portions.</p>
          <p>Available with <strong>Flexographic printing only</strong> — excellent coverage and durability for wholesale runs.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">8oz (280ml)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Colours Available:</span> <span class="spec-value">1-5 colours (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your flexographic printing artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8oz_Paper_Bowl_Template_-_322x49mm.pdf?v=1773200854" class="download-btn" download="8oz_Paper_Bowl_Wholesale_Template.pdf" target="_blank">👉 Download 8oz Wholesale Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Popular single-serving size with premium flexographic printing capabilities. Our team provides full technical support.</p>
        `,
        howItWorks: (window.getWholesaleHowItWorksMarkup ? window.getWholesaleHowItWorksMarkup() : `
          <div class="process-timeline">
            <div class="process-step"><div class="process-number">1</div><div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div></div>
            <div class="process-step"><div class="process-number">2</div><div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div></div>
            <div class="process-step"><div class="process-number">3</div><div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bowls go into production — lead time matches the production option you select above.</div></div>
            <div class="process-step"><div class="process-number">4</div><div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div></div>
          </div>
        `)
      },
      "16oz": {
        description: `
          <p>Our 16oz Wholesale Custom Paper Bowls suit regular serves for retail and venues. Built for scale with durable materials.</p>
          <p>Available with <strong>Flexographic printing only</strong> — high-speed, consistent print for large runs.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">16oz (440ml)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Colours Available:</span> <span class="spec-value">1-5 colours (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your flexographic printing artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Paper_Bowl_Template_-_320x67mm.pdf?v=1773200854" class="download-btn" download="16oz_Paper_Bowl_Wholesale_Template.pdf" target="_blank">👉 Download 16oz Wholesale Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Regular-serve size with dependable print quality for scale. Our team can assist with separations and plate setup.</p>
        `,
        howItWorks: (window.getWholesaleHowItWorksMarkup ? window.getWholesaleHowItWorksMarkup() : `
          <div class="process-timeline">
            <div class="process-step"><div class="process-number">1</div><div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div></div>
            <div class="process-step"><div class="process-number">2</div><div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div></div>
            <div class="process-step"><div class="process-number">3</div><div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bowls go into production — lead time matches the production option you select above.</div></div>
            <div class="process-step"><div class="process-number">4</div><div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div></div>
          </div>
        `)
      },
      "20oz": {
        description: `
          <p>Our 20oz Wholesale Custom Paper Bowls are designed for generous servings.</p>
          <p>Available with <strong>Flexographic printing only</strong> — exceptional consistency for premium branding at scale.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">20oz (500ml)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Colours Available:</span> <span class="spec-value">1-5 colours (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your flexographic printing artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/20oz_Paper_Bowl_Template_-_311x83mm.pdf?v=1773200855" class="download-btn" download="20oz_Paper_Bowl_Wholesale_Template.pdf" target="_blank">👉 Download 20oz Wholesale Template</a>
        `,
        howItWorks: (window.getWholesaleHowItWorksMarkup ? window.getWholesaleHowItWorksMarkup() : `
          <div class="process-timeline">
            <div class="process-step"><div class="process-number">1</div><div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div></div>
            <div class="process-step"><div class="process-number">2</div><div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div></div>
            <div class="process-step"><div class="process-number">3</div><div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bowls go into production — lead time matches the production option you select above.</div></div>
            <div class="process-step"><div class="process-number">4</div><div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div></div>
          </div>
        `)
      },
      "25oz": {
        description: `
          <p>Our 25oz Wholesale Custom Paper Bowls are robust formats suited to main dishes and large takeaway portions.</p>
          <p>Available with <strong>Flexographic printing only</strong>.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">25oz (600ml)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Colours Available:</span> <span class="spec-value">1-5 colours (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your flexographic printing artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/25oz_Paper_Bowl_Template_-_308x94mm.pdf?v=1773200854" class="download-btn" download="25oz_Paper_Bowl_Wholesale_Template.pdf" target="_blank">👉 Download 25oz Wholesale Template</a>
        `,
        howItWorks: (window.getWholesaleHowItWorksMarkup ? window.getWholesaleHowItWorksMarkup() : `
          <div class="process-timeline">
            <div class="process-step"><div class="process-number">1</div><div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div></div>
            <div class="process-step"><div class="process-number">2</div><div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div></div>
            <div class="process-step"><div class="process-number">3</div><div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bowls go into production — lead time matches the production option you select above.</div></div>
            <div class="process-step"><div class="process-number">4</div><div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div></div>
          </div>
        `)
      },
      "30oz": {
        description: `
          <p>Our 30oz Wholesale Custom Paper Bowls - our largest format suitable for family size portions.</p>
          <p>Available with <strong>Flexographic printing only</strong>.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">30oz (700ml)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Colours Available:</span> <span class="spec-value">1-5 colours (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your flexographic printing artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/30oz_Paper_Bowl_Template_-_304x107mm.pdf?v=1773200854" class="download-btn" download="30oz_Paper_Bowl_Wholesale_Template.pdf" target="_blank">👉 Download 30oz Wholesale Template</a>
        `,
        howItWorks: (window.getWholesaleHowItWorksMarkup ? window.getWholesaleHowItWorksMarkup() : `
          <div class="process-timeline">
            <div class="process-step"><div class="process-number">1</div><div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div></div>
            <div class="process-step"><div class="process-number">2</div><div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div></div>
            <div class="process-step"><div class="process-number">3</div><div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bowls go into production — lead time matches the production option you select above.</div></div>
            <div class="process-step"><div class="process-number">4</div><div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div></div>
          </div>
        `)
      }
    };

    return sizeDescriptions;
  }

  updateDynamicDescription() {
    const dataMap = this.getDescriptionData();
    const data = dataMap[this.selectedSize];
    if (!data) return;

    // Desktop containers
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');

    if (descriptionContent) descriptionContent.innerHTML = data.description;
    if (specificationContent) specificationContent.innerHTML = data.specification;
    if (dielinesContent) dielinesContent.innerHTML = data.dielines;
    if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) howItWorksContent.innerHTML = data.howItWorks;

    // Mobile containers
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');

    if (descriptionContentMobile) descriptionContentMobile.innerHTML = data.description;
    if (specificationContentMobile) specificationContentMobile.innerHTML = data.specification;
    if (dielinesContentMobile) dielinesContentMobile.innerHTML = data.dielines;
    if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) howItWorksContentMobile.innerHTML = data.howItWorks;
  }

  checkCartAddSuccess() {
    // Check if there's a success message in URL params
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cart_add') === 'success') {
      this.showMessage('Added to cart successfully!', 'success');

      // Clean up URL
      const newUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }

  preventAutoScroll() {
    // Prevent automatic scrolling when updating variant
    const originalScrollTo = window.scrollTo;
    window.scrollTo = function (x, y) {
      if (arguments.length === 0) return;
      originalScrollTo.call(window, x, y);
    };
  }

  showMessage(text, type = 'info') {
    // Create and show a temporary message
    const message = document.createElement('div');
    message.className = `product-message product-message--${type}`;
    message.textContent = text;

    // Style the message
    Object.assign(message.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '1rem 1.5rem',
      backgroundColor: type === 'error' ? '#ef4444' : type === 'success' ? '#10b981' : '#3b82f6',
      color: 'white',
      borderRadius: '0.5rem',
      zIndex: '9999',
      opacity: '0',
      transition: 'opacity 0.3s ease'
    });

    document.body.appendChild(message);

    // Animate in
    setTimeout(() => {
      message.style.opacity = '1';
      message.classList.add('show');
    }, 10);

    setTimeout(() => {
      message.classList.add('hide');
      setTimeout(() => {
        message.remove();
      }, 300);
    }, 3000);
  }
}

// Smooth scroll function for ETA calculator
function scrollToEtaCalculator(event) {
  event.preventDefault();

  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();

  const upload = document.getElementById('design-upload-section');
  if (upload) {
    upload.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    return;
  }
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  console.log('✅ Initializing Paper Bowl Wholesale Product...');
  window.paperBowlWholesaleProduct = new PaperBowlWholesaleProduct();
});
